import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { theme } from 'theme';

import creditReviewFreeTrialInvitationImg from 'assets/images/credit-review-free-trial-invitation.jpg';

import { DialogTitleWithClose } from 'ui';

type InitialSubscriptionInvitiationModalProps = {
  onClose: () => void;
  open: boolean;
  onNavigateToInitialSubscription: () => void;
};

const useStyles = makeStyles(() => ({
  dialogContent: {
    minWidth: '400px',
    whiteSpace: 'pre-line',
    padding: theme.spacing(3),
  },
  heading: {
    color: '#333',
    fontWeight: 500,
    fontSize: 15,
  },
  text: {
    color: '#333',
    fontSize: 15,
  },
}));

const InitialSubscriptionInvitiationModal: FC<InitialSubscriptionInvitiationModalProps> = ({
  open,
  onClose,
  onNavigateToInitialSubscription,
}): ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm">
      <DialogTitleWithClose onClose={onClose} imageUrl={creditReviewFreeTrialInvitationImg}>
        {t('CREDIT_REVIEW.FREE_TRIAL_INVITATION_CARD_TITLE')}
      </DialogTitleWithClose>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>
          <Typography variant="h6" color="secondary" component="p" className={classes.heading}>
            {t('CREDIT_REVIEW.ACTIVATE_YOUR_CREDIT_REVIEW_FREE_TRIAL_NOW')}
          </Typography>
          <br />
          <Typography variant="body1" color="secondary" component="p" className={classes.text}>
            {t('CREDIT_REVIEW.FREE_TRIAL_INVITATION_CARD_DESC')}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          {t('CREDIT_REVIEW.FREE_TRIAL_INVITATION_MODAL_NO')}
        </Button>
        <Button variant="contained" color="primary" onClick={onNavigateToInitialSubscription}>
          {t('CREDIT_REVIEW.FREE_TRIAL_INVITATION_MODAL_YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InitialSubscriptionInvitiationModal;
